module.exports = __webpack_public_path__ + "media/img/logo_header-9a71ff5480833990a7bc47a4c68d8723.svg";